import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { FileInfo, InformacionBusquedaUsuario, InfoUnidad, ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { MesesPlanificacionHEDTO } from "../Planificacion Horas Extras/TypesPlanificacionUnidades";
import { InformacionManualHorasExtras, InformacionManualHorasExtrasServer, InformacionManualSolicitudPagoHE } from "./TypesIngresoManualSolicHE";







export const URL_CONTROLLER_APROBACION_HE = `${configData.SERVER_URL}AprobacionSolicitudesTH`
const URL_BUSCAR_SERVIDOR_CEDULA = URL_CONTROLLER_APROBACION_HE + "/InformacionUsuarioHE"

const URL_BUSCAR_SERVIDOR_NOMBREAPELLIDO = URL_CONTROLLER_APROBACION_HE + "/InformacionUsuarioHE"



export async function BuscarInformacionPersonaByIdentificacion(identificacion: string) {
    var respuesta: ResponseRequestGeneric<InformacionBusquedaUsuario | null> = {
        status: -1
    };

    try {

        const URL_COMPLETA = URL_BUSCAR_SERVIDOR_CEDULA + "/" + identificacion
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: InformacionBusquedaUsuario | null = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionBusquedaUsuario | null>(error)
    }

    return respuesta
}

export async function BuscarInformacionPersonaByNombreApellido(nombreapellido: string) {
    var respuesta: ResponseRequestGeneric<InformacionBusquedaUsuario[]> = {
        status: -1
    };

    try {

        const responseAxios = await axios.get(URL_BUSCAR_SERVIDOR_NOMBREAPELLIDO, {
            params: {
                nombreapellido: nombreapellido
            },
            headers: authHeader()
        })

        var data: InformacionBusquedaUsuario[] = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<InformacionBusquedaUsuario[]>(error)
    }

    return respuesta
}

export async function ObtenerAniosSolicitudHE() {
    const url = configData.SERVER_URL + "SolicitudPagoHorasExtras/ObtenerAniosTHHE";


    var informacionPlanificacion: number[] = []
    var infoResponse: ResponseRequestGeneric<number[]> = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}


export async function ObtenerMesesSolicitudHE(anio: number) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/ObtenerMesesPorAnioTH/${anio}`;
    var informacionPlanificacion: MesesPlanificacionHEDTO[] = []
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}

export async function ObtenerUnidadesConPresupuestoHE(anio: number, mes: number) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/ObtenerUnidadesTH/${anio}/${mes}`;
    var informacionPlanificacion: InfoUnidad[] = []
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }
        }
    }
    return infoResponse;
}


export async function ObtenerInformacionIngresoSolicitud(anio: number, mes: number, unidad: number, identificacion: string) {
    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/InformacionServidorSolicitudPagoHEManual`;

    var infoResponse: ResponseRequestGeneric<InformacionManualSolicitudPagoHE> = { status: -1, dataResponse: undefined }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeader(),
                params: {
                    anio, mes, idunidad: unidad, identificacion
                }
            }
        )

        infoResponse = {
            status: respuesta.status,
            dataResponse: respuesta.data,
        }
    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<InformacionManualSolicitudPagoHE>(error);
    }
    return infoResponse;
}


export async function GuardarBorradorSolicitudManual(
    anio: number,
    mes: number,
    unidad: number,
    identificacion: string,
    diasSolicitud: InformacionManualHorasExtrasServer[],
    idcontratolaboral:number,
    nombretabla:string,
    informacionAprobador: any

) {

    var infoResponse: ResponseRequestGeneric<void> = { status: -1, dataResponse: undefined }

    const datos = {
        diasSolicitud,
        anio,
        mes,
        unidad,
        identificacion,
        idcontratolaboral,
        nombretabla,
        informacionAprobador
    }

    const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/BorradorSolicitudManualHE`;

    try {
        const respuesta = await axios.post(url,datos,
            {
                headers: authHeader()
            }
        )

        infoResponse = {
            status: respuesta.status,
            
        }
    } catch (error) {
        infoResponse = hadleAxiosErrorResponse<void>(error);
    }
   
   return infoResponse;

}



export async function GuardarSolicitudManual(
    anio: number,
    mes: number,
    unidad: number,
    identificacion: string,
    diasSolicitud: InformacionManualHorasExtrasServer[],
    documentos: FileInfo[],
    idcontratolaboral:number,
    nombretabla:string,
    informacionAprobador: any

) {

    var infoResponse: ResponseRequestGeneric<void> = { status: -1, dataResponse: undefined }

    const formData = new FormData();


   
    var hojaMarcaciones = documentos[0]//documentos.find((v,i) => v.nombreFile === "hojaMarcaciones")
    var formularioHE = documentos[1] // documentos.find((v,i) => v.nombreFile === "formularioHE")


    if(hojaMarcaciones.file instanceof File && formularioHE.file instanceof File){
    
        

        formData.append("HojaMarcaciones",hojaMarcaciones.file,hojaMarcaciones.file.name)
        formData.append("FormularioHE",formularioHE.file,formularioHE.file.name)

        const datos = {
            diasSolicitud,
            anio,
            mes,
            unidad,
            identificacion,
            idcontratolaboral,
            nombretabla,
            informacionAprobador
        }
        formData.append("Datos", JSON.stringify(datos));

        

        const url = configData.SERVER_URL + `SolicitudPagoHorasExtras/SolicitudManualHE`;

        
        try {
            const respuesta = await axios.post(url,formData,
                {
                    headers: authHeader()
                }
            )
    
            infoResponse = {
                status: respuesta.status,
                
            }
        } catch (error) {
            infoResponse = hadleAxiosErrorResponse<void>(error);
        }
        return infoResponse;

    }else {
        infoResponse.errorMessage = "Archivos no válidos"
        return infoResponse;
    }
    

   
    


   

}